import { createTheme } from '@mui/material';
var augmentColor = createTheme().palette.augmentColor;
export var palette = {
    primary: augmentColor({
        color: {
            main: '#CF4520',
        },
    }),
    secondary: augmentColor({
        color: {
            main: '#0A0A0A',
        },
    }),
    tertiary: augmentColor({
        color: {
            main: '#3C7AB4',
        },
    }),
    error: augmentColor({
        color: {
            main: '#ff5252',
        },
    }),
    warning: augmentColor({
        color: {
            main: '#ffea00',
        },
    }),
    info: augmentColor({
        color: {
            main: '#62cae6',
        },
    }),
    success: augmentColor({
        color: {
            main: '#66bb6a',
        },
    }),
    text: {
        primary: '#1E1D1B',
    },
    common: {
        black: '#0A0A0A',
        white: '#fff',
        purple: '#A154BA',
        salmon: '#FB9C84',
        'faux-white': '#F4F4F4',
    },
    custom: {
        normalCategory: augmentColor({
            color: { main: '#98bc24' },
        }),
        mildCategory: augmentColor({
            color: { main: '#e57508' },
        }),
        moderateCategory: augmentColor({
            color: { main: '#c32d0e' },
        }),
    },
};
